<template>
  <div class="bg-default-dashboard">
    <div class=" py-lg-8 pt-lg-5">
      <b-container fluid style="width: 90%;">
        <!-- <div class="header-body "  > -->
        <b-row class="mb-2">
          <b-col md="6" xl="8">
            <h1 class="text-white">Safety Observation Dashboard</h1>
          </b-col>
          <!-- 
          <b-col md="6" xl="4">
            <div class="d-flex flex-column h-100 w-100 p-2">
              <div class="d-flex flex-column h-100 w-100 flex-grow-1 flex-shrink-1">
                <div class="d-flex flex-column flex-grow-1 flex-shrink-1">
                  <div style="padding: 4px;" class="btn-toolbar">
                    <span>
                      <base-button type="dark" @click="action_on_modal('show', 'modal-filter', false)">
                        <span><i class="icon-filter-search-cs mr-1"></i></span>
                        <span class=""><strong>Filter</strong></span>
                        <span><i class="icon-sort-down-cs ml-6" style="font-size: large;"></i></span>
                      </base-button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>           
          -->
          <b-col md="6" xl="4" style="display: none;">
            <div class="d-flex flex-column h-100 w-100 p-2">
              <div class="d-flex flex-column h-100 w-100 flex-grow-1 flex-shrink-1">
                <div class="d-flex flex-column flex-grow-1 flex-shrink-1">
                  <div style="padding: 4px;" class="btn-toolbar">
                    <span>
                      <div class="d-block">
                        <!-- date | time | project name | site name -->
                        <b-row class="mb-3">
                          <b-col>
                            <base-input name="From Date" type="date" v-model="filter.from_date"></base-input>
                          </b-col>
                          <b-col>
                            <base-input name="To Date" type="date" v-model="filter.to_date"></base-input>
                          </b-col>
                          <b-col>
                            <base-button type="success" @click="getprojectListing()">Submit Filter</base-button>
                          </b-col>
                        </b-row>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
        <!-- 
        <b-row>
          <div class="d-flex flex-column h-100 w-100 p-2">
            <div class="d-flex flex-column h-100 w-100 flex-grow-1 flex-shrink-1">
              <div class="d-flex flex-column flex-grow-1 flex-shrink-1">
                <div style="padding: 4px;" class="btn-toolbar">
                  <span>
                    <base-button type="dark" @click="action_on_modal('show', 'modal-filter', false)">
                      <span><i class="icon-filter-search-cs mr-1"></i></span>
                      <span class=""><strong>Filter</strong></span>
                      <span><i class="icon-sort-down-cs ml-6" style="font-size: large;"></i></span>
                    </base-button>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </b-row> 
        -->

        <!-- dashboard total capacity | total turn on | total site turn on -->
        <b-row class="mb-2">
          <!-- high-risk & late -->
          <b-col>
            <b-row>
              <b-col>
                <card class="bg-card-dashboard dashboard-panel-risk-high">
                  <b-row>
                    <b-col>
                      <!-- <div class="h1 mb-1" style="text-align: center; font-size: 45px; color: #ed0101;"> HIGH-RISK & LATE</div> -->
                      <div class="text-white h1 mb-1" style="text-align: center; font-size: 45px;"> HIGH-RISK & LATE
                      </div>
                    </b-col>
                  </b-row>
                  <b-row style="text-align: center;">
                    <b-col>
                      <b-row>
                        <b-col>
                          <!-- <div class="text-white h4 mb-1"> Total Capacity</div> -->
                          <!-- <span class="h1" style="font-size: 80px; color: #ed0101;">{{ oReport.high_risk_open_late.total }}</span> -->
                          <span class="text-white h1" style="font-size: 80px;">{{ oReport.high_risk_open_late.total
                          }}</span>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <!-- <span class="" style="font-size: 35px; color: #ed0101;"><small>cases</small></span> -->
                          <span class="text-white" style="font-size: 35px;"><small>cases</small></span>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </card>
              </b-col>
            </b-row>
          </b-col>
          <!-- high risk & open -->
          <b-col>
            <b-row>
              <b-col>
                <card class="bg-card-dashboard dashboard-panel-risk-medium">
                  <b-row>
                    <b-col>
                      <!-- <div class="h1 mb-1" style="text-align: center; font-size: 45px; color: #ffb645;" > HIGH-RISK & OPEN</div> -->
                      <div class="text-white h1 mb-1" style="text-align: center; font-size: 45px;"> HIGH-RISK & OPEN
                      </div>
                    </b-col>
                  </b-row>
                  <b-row style="text-align: center;">
                    <b-col>
                      <b-row>
                        <b-col>
                          <!-- <div class="text-white h4 mb-1"> Total Capacity</div> -->
                          <!-- <span class="h1" style="font-size: 80px; color: #ffb645;">{{ oReport.high_risk_open_not_late.total }}</span>  -->
                          <span class="text-white h1" style="font-size: 80px;">{{ oReport.high_risk_open_not_late.total
                          }}</span>
                          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          <!-- <span class="" style="font-size: 35px; color: #ffb645;"><small>cases</small></span> -->
                          <span class="text-white" style="font-size: 35px;"><small>cases</small></span>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </card>
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <hr class="hr" />

        <!-- MONTHLY -->
        <b-row class="mb-3 mt-2">
          <b-col md="12" xl="12">
            <span>
              <h1 class="text-white">Monthly Report for {{ oReport.selected.month }} {{ oReport.selected.year }}</h1>
            </span>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col md="6" xl="6">
            <vue-highcharts :options="obj_chart.risk_by_late_cases" ref="chart_risk_by_late_cases"></vue-highcharts>
          </b-col>
          <b-col md="6" xl="6">
            <vue-highcharts :options="obj_chart.risk_by_open_cases" ref="chart_risk_by_open_cases"></vue-highcharts>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col md="6" xl="6">
            <vue-highcharts :options="obj_chart.safety_by_observation"
              ref="chart_safety_by_observation"></vue-highcharts>
          </b-col>
          <b-col md="6" xl="6">
            <vue-highcharts :options="obj_chart.safety_by_risk_type" ref="chart_safety_by_risk_type"></vue-highcharts>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col md="4" xl="4">
            <vue-highcharts :options="obj_chart.closure_freq_by_severity_high"
              ref="chart_closure_freq_by_severity_high"></vue-highcharts>
          </b-col>
          <b-col md="4" xl="4">
            <vue-highcharts :options="obj_chart.closure_freq_by_severity_medium"
              ref="chart_closure_freq_by_severity_medium"></vue-highcharts>
          </b-col>
          <b-col md="4" xl="4">
            <vue-highcharts :options="obj_chart.closure_freq_by_severity_low"
              ref="chart_closure_freq_by_severity_low"></vue-highcharts>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col md="12" xl="12">
            <vue-highcharts :options="obj_chart.bar_closure_by_epc" ref="chart_bar_closure_by_epc"></vue-highcharts>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col md="12" xl="12">
            <vue-highcharts :options="obj_chart.bar_closure_by_safety"
              ref="chart_bar_closure_by_safety"></vue-highcharts>
          </b-col>
        </b-row>

        <hr class="hr" />

        <!-- YTD -->
        <b-row class="mb-3 mt-2">
          <b-col md="12" xl="12">
            <span>
              <h1 class="text-white">YTD {{ oReport.selected.year }}</h1>
            </span>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col md="12" xl="12">
            <vue-highcharts :options="obj_chart.bar_ytd_by_type" ref="chart_bar_ytd_by_type"></vue-highcharts>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col md="12" xl="12">
            <vue-highcharts :options="obj_chart.bar_ytd_by_status" ref="chart_bar_ytd_by_status"></vue-highcharts>
          </b-col>
        </b-row>

      </b-container>

      <!-- Modal filter -->
      <b-modal ref="modal-filter" size="lg" centered hide-footer hide-header title="">
        <div class="d-block">
          <!-- date | time | project name | site name -->
          <b-row class="mb-3">
            <b-col>
              <!-- <b-form-datepicker placeholder="Form Date" v-model="valuePMN" class="text-white mb-2"></b-form-datepicker> -->
              <base-input name="From Date" type="date" v-model="filter.from_date"></base-input>
            </b-col>
            <b-col>
              <!-- <b-form-datepicker placeholder="Form Date" v-model="valuePMN" class="text-white mb-2"></b-form-datepicker> -->
              <base-input name="To Date" type="date" v-model="filter.to_date"></base-input>
            </b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col>
              <select multiple class="form-control" id="developersSelect" v-model="filter.developers" size="3">
                <option v-for="item in developers" :key="item.developer_id" v-bind:value="item.developer_id">
                  {{ item.developer_code }}
                </option>
              </select>
            </b-col>
          </b-row>

          <!-- detail filter selection -->
          <b-row>
            <b-col class="text-right">
              <!-- <base-button type="success">Search</base-button> -->
              <base-button type="success" @click="getprojectListing()">Search</base-button>
            </b-col>
          </b-row>
        </div>
      </b-modal>

      <modal :show.sync="isLoadingInProgress" ref="modal-loading" size="lg" modal-classes="in-progress-modal-lg"
        :no-close-on-backdrop="true" body-classes="p-0">
        <card type="secondary" header-classes="bg-transparent pb-5" body-classes="px-lg-5 py-lg-5"
          class="border-0 mb-0">
          <template>
            <div class="text-center text-muted mb-4">
              <h1 class="text-white"><b>Loading in progress</b></h1>
            </div>
            <div class="text-center">
              <div style="color: #ffffff;">
                <!-- <span class="fa fa-spinner fa-spin fa-3x"></span> -->
                <span class="icon-spinner-cs"></span>
              </div>
            </div>
          </template>
        </card>
      </modal>
    </div>


  </div>
</template>

<script>
import axios from '@/util/axios';
import { LoginURL, clientId, clientSecret, apiDomain, getHeader, getcurrentDate } from '@/assets/js/config.js';
import moment from "moment";
import VueHighcharts from 'vue2-highcharts'

import ErrorFunctionMixin from '@/assets/js/errorFunctionMix.js';
import CustomLibHelper from "@/assets/js/customLibHelper.js";
import { cloneDeep } from "lodash";

// const api = shallowRef();

export default {
  mixins: [ErrorFunctionMixin, CustomLibHelper],
  created() {
    this.setDefaultMonthRange();

    var safety_observation_access = JSON.parse(
      window.localStorage.getItem("safety_observation_access")
    );

    const LoginUser = JSON.parse(window.localStorage.getItem("loginUser"));
    this.myUserID = LoginUser;

    // const userInfo = JSON.parse(window.localStorage.getItem("loginUser"));
    // this.user_role = userInfo.role_id;
    // this.user_id = userInfo.id;

    // this.getUserList();
  },
  components: {
    VueHighcharts,
  },
  data() {
    return {
      oDev: {
        debug: false,
      },
      oDashboard: {
        list_project: null,
        list_safety: null,
      },
      obj_chart: {
        risk_by_late_cases: null,
        risk_by_open_cases: null,
        safety_by_observation: null,
        safety_by_risk_type: null,
        closure_freq_by_severity_high: null,
        closure_freq_by_severity_medium: null,
        closure_freq_by_severity_low: null,
        bar_closure_by_epc: null,
        bar_closure_by_safety: null,
        bar_ytd_by_type: null,
        bar_ytd_by_status: null,
      },
      oReport: {
        selected: { year: '', month: '', month_mmm: '', currDDMmmYYYY: '' },
        pn_all: { total: 0, positive: 0, negative: 0 },
        pn_all_by_severity: { total: 0, high: 0, medium: 0, low: 0 },
        pn_all_by_status: { total: 0, open: 0, close: 0, draft: 0 },
        no_all_by_status: { total: 0, open: 0, close: 0, draft: 0 },  //_ negative only
        pn_safety: null, // { total: 0, positive: 0, negative: 0 },
        pn_project_engineer: null, // { 'total': 0, 'positive': 0, 'negative': 0 },
        pn_project_manager: null, // { 'total': 0, 'positive': 0, 'negative': 0 },
        pn_epc: null, // { 'total': 0, 'positive': 0, 'negative': 0 },
        cbn_all: { total: 0, late: 0, ontime: 0 },
        cbn_epc: [], // { 'total': 0 , 'late': 0, 'ontime': 0},
        cbp_epc: null, // { 'total': 0 , 'late': 0, 'ontime': 0},
        cbn_safety: null, // { 'total': 0 , 'late': 0, 'ontime': 0},
        high_risk_open_late: { total: 0 },
        high_risk_open_not_late: { total: 0 },
        open_late_cases: { total: 0, high: 0, medium: 0, low: 0 },
        open_not_late_cases: { total: 0, high: 0, medium: 0, low: 0 },
        // closure_freq_by_severity_high: { total: 0, late: 0, ontime: 0 },
        // closure_freq_by_severity_medium: { total: 0, late: 0, ontime: 0 },
        // closure_freq_by_severity_low: { total: 0, late: 0, ontime: 0 },
        closure_freq_by_severity_high: { total: 0, closed_late: 0, closed_ontime: 0, open_late: 0 },
        closure_freq_by_severity_medium: { total: 0, closed_late: 0, closed_ontime: 0, open_late: 0 },
        closure_freq_by_severity_low: { total: 0, closed_late: 0, closed_ontime: 0, open_late: 0 },
        ytd_by_type: [],
        ytd_by_status: [],
      },
      oTemplate: {
        chart_pie_v1: {
          credits: {
            enabled: false,
          },
          series: [
            {
              name: "Total",
              colorByPoint: true,
              dataLabels: {
                enabled: true,
                style: {
                  textOutline: 'none',
                  fontSize: '14px',
                  fontFamily: "Open Sans, sans-serif",
                  fontWeight: "bold",
                  color: '#ffffff'
                }
              },
              data: [],
            },
          ],
          chart: {
            height: '60%',
            type: "pie",
            backgroundColor: "#23454A",
            // reflow: true,
          },
          plotOptions: {
            pie: {
              showInLegend: true,
              dataLabels: {
                enabled: true,
                // format: '<b>{point.name}</b>:<br>{point.percentage:.1f} %<br>value: {point.y}',
                format: '<b>{point.name}</b>: {point.y}',
              }
            }
          },
          legend: {
            itemStyle: {
              color: '#FFFFFF'
            },
            itemHoverStyle: {
              color: '#c1c1c1'
            },
          },
          title: {
            text: '',
            style: {
              color: "white",
              fontWeight: "bold",
            },
          },
        },
        chart_bar_v1: {
          chart: {
            type: 'column'
          },
          // colors: [
          //   '#25ff19',    //_ green
          //   '#f51d1d',    //_ red
          //   '#ffb012'     //_ orange / yellow
          // ],
          title: {
            text: ''
          },
          // subtitle: {
          //   text:
          //     'Source: <a target="_blank" ' +
          //     'href="https://www.indexmundi.com/agriculture/?commodity=corn">indexmundi</a>'
          // },
          xAxis: {
            // categories: ['USA', 'China', 'Brazil', 'EU', 'Argentina', 'India'],
            categories: [],
            crosshair: true,
            accessibility: {
              description: 'Countries'
            }
          },
          yAxis: {
            min: 0,
            title: {
              // text: '1000 metric tons (MT)'
              text: ''
            }
          },
          tooltip: {
            // valueSuffix: ' (1000 MT)'
            valueSuffix: ''
          },
          plotOptions: {
            column: {
              pointPadding: 0.2,
              borderWidth: 0
            }
          },
          series: [
            // {
            //   name: 'Corn',
            //   data: [387749, 280000, 129000, 64300, 54000, 34300]
            // },
            // {
            //   name: 'Wheat',
            //   data: [45321, 140000, 10000, 140500, 19500, 113500]
            // }
          ]
        }
      },
      myUserID: null,
      // myUserDetail: null,
      // user_role: null,
      // user_id: null,
      // contractor_id: null,
      // developers: [],
      developers: [
        { developer_id: 1, developer_code: "Sembcorp Solar Singapore", developer_name: "Sembcorp Solar Singapore" },
        { developer_id: 2, developer_code: "Sembcorp Energy Indonesia", developer_name: "Sembcorp Energy Indonesia" }
      ],
      // api: null,
      filter: {
        developers: [1],
        project_name: null,
        project_site_contractors: [],
        site_name: null,
        project_safety: [],
        safety_inspection_submitter: [],

        from_date: null,
        to_date: null,

        safety_observation_type: [],
        safety_observation_category: [],
        safety_observation_priority: [],

        target_date_from_date: null,
        target_date_to_date: null,

      },
      isLoadingInProgress: false,
      isFromDateAfterToDate: false,
    }
  },
  beforeMount() {

  },
  mounted() {
    // this.getprojectListing();

    this.getDashboardData();
  },
  methods: {
    getprojectListing() {
      this.devMsg(this.oDev.debug, 'getprojectListing', 'gs')

      this.isLoadingInProgress = true;

      axios
        .get(apiDomain + "project/project", { headers: getHeader() })
        .then((response) => {
          if (response.status === 200) {
            console.log(response.data.data);
            let raw_data = response.data.data;

            const arr_simplify1 = raw_data.map(
              // ({ project, site, contractor, safety_observation_items, conducting_users }) => ({
              ({ project_id, project_name, project_manager, project_engineer, project_safety, developer, project_type, project_category }) => ({
                project_code: project_id,
                project_name: project_name,
                project_developer: developer.developer_name,
                project_type: project_type.project_type,
                project_category: project_category.project_category,
                project_manager_id: project_manager.id,
                project_manager_name: project_manager.name,
                project_engineer_id: project_engineer.id,
                project_engineer_name: project_engineer.name,
                project_safety_id: project_safety.id,
                project_safety_name: project_safety.name,
              })
            );
            this.devMsg(this.oDev.debug, 'arr_simplify1')
            this.devMsg(this.oDev.debug, arr_simplify1)

            this.oDashboard.list_project = arr_simplify1;

            this.devMsg(this.oDev.debug, '', 'ge')

            // this.testUnit();
            this.getSafetyListing();
          }
        })
        .catch((error) => {
          console.log(error);
          this.errorFunction(error, "Project Information");
        });
    },
    getSafetyListing() {
      this.devMsg(this.oDev.debug, 'getSafetyListing', 'gs')

      this.devMsg(this.oDev.debug, this.filter)

      //_ get safety data
      axios
        // .post(apiDomain + "health_safety/safety_observation.show_by_filter", filter, { headers: getHeader(), })
        .post(apiDomain + "health_safety/safety_observation.show_by_filter", this.filter, { headers: getHeader(), })
        .then(response => {
          if (response.status === 200) {
            this.devMsg(this.oDev.debug, 'response.data.data')
            this.devMsg(this.oDev.debug, response.data.data)

            this.devMsg(this.oDev.debug, '', 'ge')

            this.transformSafetyObservations_v3(response.data.data);
          }
        })
        .catch(error => {
          this.errorFunction(error, "Search Safety Inspection Listing")
        });
    },
    transformSafetyObservations_v3(jsonData) {
      this.devMsg(this.oDev.debug, 'transformSafetyObservations_v3', 'gs')
      this.devMsg(this.oDev.debug, 'jsonData')
      this.devMsg(this.oDev.debug, jsonData)

      //_ simplify the data because we don't need all fields
      const arr_simplify1 = jsonData.map(
        // ({ project, site, contractor, safety_observation_items, conducting_users }) => ({
        ({ safety_observation_id, safety_observation_create_date, project, site, contractor, safety_observation_items }) => ({
          observation_id: safety_observation_id,
          observation_date: safety_observation_create_date,
          project_code: project.project_id,
          project_name: project.project_name,
          site_code: site.site_id,
          site_name: site.site_name,
          contractor_code: contractor.contractor_code,
          contractor_name: contractor.contractor_name,
          // conduct_by_code: conducting_users[0].safety_observation_conducting_user.id,
          // conduct_by_name: conducting_users[0].safety_observation_conducting_user.name,
          safety_observation_items,
        })
      );
      this.devMsg(this.oDev.debug, 'arr_simplify1');
      this.devMsg(this.oDev.debug, arr_simplify1);

      //_ transform the data into flat array, by turning the observation items as separated entries while retaining the parent information
      let transformedData = [];
      arr_simplify1.forEach(observation => {
        let parentFields = { ...observation };
        delete parentFields.safety_observation_items;

        observation.safety_observation_items.forEach(item => {
          let newItem = {
            ...parentFields,
            // ...item
            observation_item_id: item.safety_observation_item_id,
            observation_type: item.safety_observation_type.safety_observation_type_code,
            observation_category: item.safety_observation_category.safety_observation_category,
            observation_priority: (item.safety_observation_priority === null) ? '' : item.safety_observation_priority.safety_observation_priority_name,
            observation_status: item.safety_observation_status.status_code,
            observation_date_target: item.target_date,
            observation_date_resolve: item.resolved_at,
            observation_repeated: item.repeated_observation,
          };
          transformedData.push(newItem);
        });
      });
      this.devMsg(this.oDev.debug, 'transformedData')
      this.devMsg(this.oDev.debug, transformedData)

      this.oDashboard.list_safety = transformedData;

      this.devMsg(this.oDev.debug, '', 'ge')

      this.processSummaryReport();

      return transformedData;
    },
    processSummaryReport() {
      this.devMsg(this.oDev.debug, 'processSummaryReport', 'gs')

      this.devMsg(this.oDev.debug, 'this.oDashboard.list_project')
      this.devMsg(this.oDev.debug, this.oDashboard.list_project)
      this.devMsg(this.oDev.debug, 'this.oDashboard.list_safety')
      this.devMsg(this.oDev.debug, this.oDashboard.list_safety)

      let iCount1 = 0, iCount2 = 0, iCount3 = 0;
      let arrSafety = this.oDashboard.list_safety;

      //_ reporting data summary
      let oReport = {
        'pn_all': { 'total': 0, 'positive': 0, 'negative': 0 },
        'pn_all_by_severity': { 'total': 0, 'high': 0, 'medium': 0, 'low': 0 },
        'pn_all_by_status': { 'total': 0, 'open': 0, 'close': 0, 'draft': 0 },
        'pn_safety': null, // { 'total': 0, 'positive': 0, 'negative': 0 },
        'pn_project_engineer': null, // { 'total': 0, 'positive': 0, 'negative': 0 },
        'pn_project_manager': null, // { 'total': 0, 'positive': 0, 'negative': 0 },
        'pn_epc': null, // { 'total': 0, 'positive': 0, 'negative': 0 },
        'cbn_all': { 'total': 0, 'late': 0, 'ontime': 0 },
        'cbn_epc': null, // { 'total': 0 , 'late': 0, 'ontime': 0},
        'high_risk_open_late': { 'total': 0 },
        'high_risk_open_not_late': { 'total': 0 },
        'open_late_cases': { 'total': 0, 'high': 0, 'medium': 0, 'low': 0 },
        'open_not_late_cases': { 'total': 0, 'high': 0, 'medium': 0, 'low': 0 },
        'closure_freq_by_severity_high': { 'total': 0, 'late': 0, 'ontime': 0 },
        'closure_freq_by_severity_medium': { 'total': 0, 'late': 0, 'ontime': 0 },
        'closure_freq_by_severity_low': { 'total': 0, 'late': 0, 'ontime': 0 },
      }

      //_ version 1
      // const map = new Map();
      // this.oDashboard.list_project.forEach(item => map.set(item.project_code, item ));
      // this.oDashboard.list_safety.forEach(item => map.set(item.project_code, {...map.get(item.project_code), ...item}));
      // const mergedArr = Array.from(map.values());
      // this.devMsg(this.oDev.debug, 'mergedArr')
      // this.devMsg(this.oDev.debug, mergedArr)

      //_ version 2 -> basically this thing pivoting data between list safety with list project, because we need information of project engineer, project manager and safety that is store in the project. 
      let arr1 = this.oDashboard.list_safety;
      let arr2 = this.oDashboard.list_project;
      const mergeById = (a1, a2) => a1.map(itm => ({
        ...a2.find((item) => (item.project_code === itm.project_code) && item),
        ...itm
      })
      );

      let arrPivot = mergeById(arr1, arr2);
      this.devMsg(this.oDev.debug, 'arrPivot')
      this.devMsg(this.oDev.debug, arrPivot)

      let arrTransformed = arrPivot.filter(element => (element.observation_status === 'Open' || element.observation_status === 'Closed'));
      // this.devMsg(this.oDev.debug, 'mergeById')
      // this.devMsg(this.oDev.debug, mergeById(arr1, arr2))
      this.devMsg(this.oDev.debug, 'arrTransformed')
      this.devMsg(this.oDev.debug, arrTransformed)

      /*
        Positive
        Good Practice
        Unsafe Act
        Unsafe Condition
        Near Miss
      */
      let tmpResult = null;

      //_ all by observation type
      //  'pn_all': { 'total': 0, 'positive': 0, 'negative': 0 },
      this.oReport.pn_all.total = arrTransformed.length;
      tmpResult = arrTransformed.filter(element => (element.observation_type === 'Positive' || element.observation_type === 'Good Practice'));
      this.oReport.pn_all.positive = tmpResult.length;
      tmpResult = arrTransformed.filter(element => (element.observation_type === 'Unsafe Act' || element.observation_type === 'Unsafe Condition' || element.observation_type === 'Near Miss'));
      this.oReport.pn_all.negative = tmpResult.length;

      //_ negative only by status
      // no_all_by_status: { total: 0, open: 0, close: 0, draft: 0 }
      let arrNegativeOnly = arrTransformed.filter(element => (element.observation_type === 'Unsafe Act' || element.observation_type === 'Unsafe Condition' || element.observation_type === 'Near Miss'));
      this.oReport.no_all_by_status.total = arrNegativeOnly.length;
      tmpResult = arrNegativeOnly.filter(element => (element.observation_status === 'Open'));
      this.oReport.no_all_by_status.open = tmpResult.length;
      tmpResult = arrNegativeOnly.filter(element => (element.observation_status === 'Closed'));
      this.oReport.no_all_by_status.close = tmpResult.length;

      //_ all by status
      //  'pn_all_by_status': { 'total': 0, 'open': 0, 'close': 0, 'draft': 0 },
      this.oReport.pn_all_by_status.total = arrTransformed.length;
      tmpResult = arrTransformed.filter(element => (element.observation_status === 'Closed'));
      this.oReport.pn_all_by_status.close = tmpResult.length;
      tmpResult = arrTransformed.filter(element => (element.observation_status === 'Open'));
      this.oReport.pn_all_by_status.open = tmpResult.length;
      tmpResult = arrTransformed.filter(element => (element.observation_status === 'Draft'));
      this.oReport.pn_all_by_status.draft = tmpResult.length;

      //_ all by severity
      //  'pn_all_by_severity': { 'total': 0, 'high': 0, 'medium': 0, 'low': 0 },
      this.oReport.pn_all_by_severity.total = arrTransformed.length;   //_ why not tally ?
      tmpResult = arrTransformed.filter(element => (element.observation_priority === '1'));
      this.oReport.pn_all_by_severity.high = tmpResult.length;
      tmpResult = arrTransformed.filter(element => (element.observation_priority === '2'));
      this.oReport.pn_all_by_severity.medium = tmpResult.length;
      tmpResult = arrTransformed.filter(element => (element.observation_priority === '3'));
      this.oReport.pn_all_by_severity.low = tmpResult.length;

      // closed all
      // tmpResult = arrTransformed.filter(element => ( element.observation_status === 'Closed' ));
      // this.devMsg(this.oDev.debug, 'closed all')
      // this.devMsg(this.oDev.debug, tmpResult.length)
      // this.devMsg(this.oDev.debug, tmpResult)

      //_ closed and negative
      let arrClosedNegative = arrTransformed.filter(element => ((element.observation_type === 'Unsafe Act' || element.observation_type === 'Unsafe Condition' || element.observation_type === 'Near Miss') && element.observation_status === 'Closed'));
      this.oReport.cbn_all.total = arrClosedNegative.length;
      this.devMsg(this.oDev.debug, 'closed negative only')
      this.devMsg(this.oDev.debug, arrClosedNegative.length)
      this.devMsg(this.oDev.debug, arrClosedNegative)

      //_ closed - late
      let arrClosedNegativeLate = arrClosedNegative.filter(element => (element.observation_date_resolve > element.observation_date_target));
      this.oReport.cbn_all.late = arrClosedNegativeLate.length;
      this.devMsg(this.oDev.debug, 'closed - late')
      this.devMsg(this.oDev.debug, arrClosedNegativeLate)

      //_ closed - ontime
      let arrClosedNegativeOntime = arrClosedNegative.filter(element => (element.observation_date_resolve <= element.observation_date_target));
      this.oReport.cbn_all.ontime = arrClosedNegativeOntime.length;
      this.devMsg(this.oDev.debug, 'closed - ontime')
      this.devMsg(this.oDev.debug, arrClosedNegativeOntime)

      //_ high risk, open and late
      //  'high_risk_open_late': { 'total': 0 },
      let arrHighRiskOpen = arrTransformed.filter(element => (element.observation_priority === '1' && element.observation_status === 'Open'));
      let arrHighRiskOpen_late = arrHighRiskOpen.filter(element => (this.oReport.selected.currDDMmmYYYY > element.observation_date_target));
      this.oReport.high_risk_open_late.total = arrHighRiskOpen_late.length;

      //_ high risk, open and not late
      //  'high_risk_open_not_late': { 'total': 0 },
      let arrHighRiskOpen_not_late = arrHighRiskOpen.filter(element => (element.observation_date_resolve <= element.observation_date_target));
      this.oReport.high_risk_open_not_late.total = arrHighRiskOpen_not_late.length;

      // risk breakdown of late cases: open & late
      //  'open_late_cases': { 'total': 0, 'high': 0, 'medium': 0, 'low': 0 }, 
      this.oReport.open_late_cases.total = arrHighRiskOpen_late.length;
      tmpResult = arrHighRiskOpen_late.filter(element => (element.observation_priority === '1'));
      this.oReport.open_late_cases.high = tmpResult.length;
      tmpResult = arrHighRiskOpen_late.filter(element => (element.observation_priority === '2'));
      this.oReport.open_late_cases.medium = tmpResult.length;
      tmpResult = arrHighRiskOpen_late.filter(element => (element.observation_priority === '3'));
      this.oReport.open_late_cases.low = tmpResult.length;

      // risk breakdown of open cases: open & not late
      //  'open_not_late_cases': { 'total': 0, 'high': 0, 'medium': 0, 'low': 0 }, 
      this.oReport.open_not_late_cases.total = arrHighRiskOpen_not_late.length;
      tmpResult = arrHighRiskOpen_not_late.filter(element => (element.observation_priority === '1'));
      this.oReport.open_not_late_cases.high = tmpResult.length;
      tmpResult = arrHighRiskOpen_not_late.filter(element => (element.observation_priority === '2'));
      this.oReport.open_not_late_cases.medium = tmpResult.length;
      tmpResult = arrHighRiskOpen_not_late.filter(element => (element.observation_priority === '3'));
      this.oReport.open_not_late_cases.low = tmpResult.length;


      let arrSeverity_high = arrTransformed.filter(element => (element.observation_priority === '1'));
      this.oReport.closure_freq_by_severity_high.total = arrSeverity_high.length;
      tmpResult = arrSeverity_high.filter(element => (element.observation_date_resolve > element.observation_date_target));
      this.oReport.closure_freq_by_severity_high.late = tmpResult.length;
      tmpResult = arrSeverity_high.filter(element => (element.observation_date_resolve <= element.observation_date_target));
      this.oReport.closure_freq_by_severity_high.ontime = tmpResult.length;

      let arrSeverity_medium = arrTransformed.filter(element => (element.observation_priority === '2'));
      this.oReport.closure_freq_by_severity_medium.total = arrSeverity_medium.length;
      tmpResult = arrSeverity_medium.filter(element => (element.observation_date_resolve > element.observation_date_target));
      this.oReport.closure_freq_by_severity_medium.late = tmpResult.length;
      tmpResult = arrSeverity_medium.filter(element => (element.observation_date_resolve <= element.observation_date_target));
      this.oReport.closure_freq_by_severity_medium.ontime = tmpResult.length;

      let arrSeverity_low = arrTransformed.filter(element => (element.observation_priority === '3'));
      this.oReport.closure_freq_by_severity_low.total = arrSeverity_low.length;
      tmpResult = arrSeverity_low.filter(element => (element.observation_date_resolve > element.observation_date_target));
      this.oReport.closure_freq_by_severity_low.late = tmpResult.length;
      tmpResult = arrSeverity_low.filter(element => (element.observation_date_resolve <= element.observation_date_target));
      this.oReport.closure_freq_by_severity_low.ontime = tmpResult.length;
      /*
        'closure_freq_by_severity_high': { 'total': 0 , 'late': 0, 'ontime': 0},
        'closure_freq_by_severity_medium': { 'total': 0 , 'late': 0, 'ontime': 0},
        'closure_freq_by_severity_low': { 'total': 0 , 'late': 0, 'ontime': 0},
      */

      //_ engineer
      // let groupBySafety = Object.groupBy(arrTransformed, entry => {
      // let groupBySafety = Map.groupBy(arrTransformed, entry => {
      //   return entry.project_safety_id;
      // });      
      // this.devMsg(this.oDev.debug, 'groupBy - safety')
      // this.devMsg(this.oDev.debug, groupBySafety)
      // console.log(arrTransformed);

      this.oReport.pn_safety = this.process_arr_by_category(arrTransformed, 'safety', 'pn');
      this.oReport.pn_project_engineer = this.process_arr_by_category(arrTransformed, 'project_engineer', 'pn');
      this.oReport.pn_project_manager = this.process_arr_by_category(arrTransformed, 'project_manager', 'pn');
      this.oReport.pn_epc = this.process_arr_by_category(arrTransformed, 'epc', 'pn');

      this.oReport.cbn_epc = this.process_arr_by_category(arrTransformed, 'epc', 'cbn');
      this.oReport.cbp_epc = this.process_arr_by_category(arrTransformed, 'epc', 'cbp');

      this.oReport.cbn_safety = this.process_arr_by_category(arrTransformed, 'safety', 'cbn');

      //_ let's add current month to YTD data
      iCount1 = this.oReport.pn_all.negative
      iCount2 = this.oReport.pn_all.positive;
      this.oReport.ytd_by_type.push({ category: this.oReport.selected.month_mmm, negative: iCount1, positive: iCount2, total: 0 });

      iCount1 = 0, iCount2 = 0; //_reset 1st, incase it use
      this.oReport.cbn_safety.forEach((e => {
        iCount1 = iCount1 + e.close_late;
        iCount2 = iCount2 + e.open_late;
      }))
      this.oReport.ytd_by_status.push({ category: this.oReport.selected.month_mmm, close: iCount1, open: iCount2, total: 0 });

      //_ draw charts
      this.draw_charts();

      //_ result 
      this.devMsg(this.oDev.debug, 'this.oReport')
      this.devMsg(this.oDev.debug, this.oReport)

      this.devMsg(this.oDev.debug, '', 'ge')

    },
    process_arr_by_category(arrData, dataBy = '', dataFormat = '') {
      /**
       * dataBy:        safety | project_engineer | project_manager | epc
       * dataFormat:    pn <positive negative> | cbn <close by negative> | cbp <close by positive>
       */

      this.devMsg(this.oDev.debug, 'process_arr_by_category by ' + dataBy, 'gs')

      //_ preparing
      if (dataBy == 'safety') {
        arrData.sort((a, b) => a.project_safety_id - b.project_safety_id);
        // arrDataProcess = arrData.map(element => ({'categoryKey': element.project_safety_id, 'categoryDisplay': element.project_safety_name, ...element}))
        // arrDataProcess = arrData.map(element => ({'categoryKey': 'test1', 'categoryDisplay': 'test2', ...element}))
        arrData.map(function (e) {
          e.categoryKey = e.project_safety_id;
          e.categoryDisplay = e.project_safety_name;
        });
      } else if (dataBy == 'project_engineer') {
        arrData.sort((a, b) => a.project_engineer_id - b.project_engineer_id);
        arrData.map(function (e) {
          e.categoryKey = e.project_engineer_id;
          e.categoryDisplay = e.project_engineer_name;
        });
      } else if (dataBy == 'project_manager') {
        arrData.sort((a, b) => a.project_manager_id - b.project_manager_id);  //_ numeric compare
        arrData.map(function (e) {
          e.categoryKey = e.project_manager_id;
          e.categoryDisplay = e.project_manager_name;
        });
      } else if (dataBy == 'epc') {
        arrData.sort((a, b) => a.contractor_code.localeCompare(b.contractor_code));   //_ string compare
        arrData.map(function (e) {
          e.categoryKey = e.contractor_code;
          e.categoryDisplay = e.contractor_name;
        });
      } else {
        //_ nothing
        // arrData.sort((a, b) => new Date(a.observation_date_target) - new Date(b.observation_date_target));  //_ date compare
      }

      // console.log('arrData');
      // console.log(arrData);

      //_ process
      let prev_key = '-start-', count1 = 0, count2 = 0, countTotal = 0;
      let iOpenLate = 0, iCloseLate = 0, iCloseOntime = 0;
      let arrReturn = [];

      if (dataFormat == 'pn') {
        arrData.forEach((entry) => {
          if (entry.categoryKey != prev_key) {
            prev_key = entry.categoryKey;
            count1 = 0, count2 = 0, countTotal = 0;
            arrReturn.push({ 'category': entry.categoryDisplay, 'total': countTotal, 'positive': count1, 'negative': count2 })
          }

          countTotal++
          (entry.observation_type === 'Positive' || entry.observation_type === 'Good Practice') ? count1++ : '';
          (entry.observation_type === 'Unsafe Act' || entry.observation_type === 'Unsafe Condition' || entry.observation_type === 'Near Miss') ? count2++ : '';

          arrReturn[arrReturn.length - 1].total = countTotal;
          arrReturn[arrReturn.length - 1].positive = count1;
          arrReturn[arrReturn.length - 1].negative = count2;
        });
      } else if (dataFormat == 'cbn') {
        // let arrClosedNegative = arrData.filter(element => ((element.observation_type === 'Unsafe Act' || element.observation_type === 'Unsafe Condition' || element.observation_type === 'Near Miss') && element.observation_status === 'Closed'));

        // arrClosedNegative.forEach((entry) => {
        //   if (entry.categoryKey != prev_key) {
        //     prev_key = entry.categoryKey;
        //     count1 = 0, count2 = 0, countTotal = 0;
        //     arrReturn.push({ 'category': entry.categoryDisplay, 'total': countTotal, 'late': count1, 'ontime': count2 })
        //   }

        //   countTotal++
        //   (entry.observation_date_resolve > entry.observation_date_target) ? count1++ : '';
        //   (entry.observation_date_resolve <= entry.observation_date_target) ? count2++ : '';

        //   arrReturn[arrReturn.length - 1].total = countTotal;
        //   arrReturn[arrReturn.length - 1].late = count1;
        //   arrReturn[arrReturn.length - 1].ontime = count2;
        // });

        let arrNegativeObs = arrData.filter(element => ((element.observation_type === 'Unsafe Act' || element.observation_type === 'Unsafe Condition' || element.observation_type === 'Near Miss')));

        arrNegativeObs.forEach((entry) => {
          if (entry.categoryKey != prev_key) {
            prev_key = entry.categoryKey;
            iOpenLate = 0, iCloseLate = 0, iCloseOntime = 0, countTotal = 0;
            arrReturn.push({ 'category': entry.categoryDisplay, 'total': countTotal, 'open_late': iOpenLate, 'close_late': iCloseLate, 'close_ontime': iCloseOntime })
          }

          countTotal++
          if (entry.observation_status === 'Closed') {
            (entry.observation_date_resolve > entry.observation_date_target) ? iCloseLate++ : '';
            (entry.observation_date_resolve <= entry.observation_date_target) ? iCloseOntime++ : '';
          } else {
            (this.oReport.selected.currDDMmmYYYY > entry.observation_date_target) ? iOpenLate++ : '';
          }

          arrReturn[arrReturn.length - 1].total = countTotal;
          arrReturn[arrReturn.length - 1].open_late = iOpenLate;
          arrReturn[arrReturn.length - 1].close_late = iCloseLate;
          arrReturn[arrReturn.length - 1].close_ontime = iCloseOntime;
        });
      } else if (dataFormat == 'cbp') {
        let arrClosedNegative = arrData.filter(element => ((element.observation_type === 'Good Practice' || element.observation_type === 'Positive Condition') && element.observation_status === 'Closed'));

        arrClosedNegative.forEach((entry) => {
          if (entry.categoryKey != prev_key) {
            prev_key = entry.categoryKey;
            count1 = 0, count2 = 0, countTotal = 0;
            arrReturn.push({ 'category': entry.categoryDisplay, 'total': countTotal, 'late': count1, 'ontime': count2 })
          }

          countTotal++
          (entry.observation_date_resolve > entry.observation_date_target) ? count1++ : '';
          (entry.observation_date_resolve <= entry.observation_date_target) ? count2++ : '';

          arrReturn[arrReturn.length - 1].total = countTotal;
          arrReturn[arrReturn.length - 1].late = count1;
          arrReturn[arrReturn.length - 1].ontime = count2;
        });
      } else {
        //_ nothing
      }

      this.devMsg(this.oDev.debug, 'arrReturn')
      this.devMsg(this.oDev.debug, arrReturn)

      this.devMsg(this.oDev.debug, '', 'ge')

      return arrReturn;
    },




    getDashboardData() {
      this.isLoadingInProgress = true;

      var currentDate = getcurrentDate();
      var localCurrentDate = new Date(currentDate);

      const currentYear = localCurrentDate.getFullYear();
      const currentMonth = String(localCurrentDate.getMonth() + 1).padStart(2, "0");
      const currentDay = String(localCurrentDate.getDate()).padStart(2, "0");

      let filter = {
        year: currentYear,
        month: currentMonth,
        developer: '1',
      };

      // console.log('filter');
      // console.log(filter);

      axios
        .post(apiDomain + "reports/health_safety_dashboard.selected_filter", filter, {
          headers: getHeader(),
        })
        .then(response => {
          if (response.status === 200) {
            this.devMsg(this.oDev.debug, 'hitTestApi', 'gs')

            this.devMsg(this.oDev.debug, 'response')
            this.devMsg(this.oDev.debug, response)

            this.devMsg(this.oDev.debug, '', 'ge')

            this.populated_dashboard_data(response.data.data);
          }
        })
        .catch(error => {
          this.errorFunction(error, "getDashboardData()")
        });

    },
    populated_dashboard_data(tmpAPIData = null) {
      this.devMsg(this.oDev.debug, 'populated_dashboard_data', 'gs')

      if (tmpAPIData === null) {
        this.isLoadingInProgress = false;
      } else {
        //_ live
        let arrContainer = tmpAPIData.filter(element => (element.section === 'live high risk' && element.category === 'open and late'));
        this.oReport.high_risk_open_late.total = arrContainer[0].counter;

        arrContainer = tmpAPIData.filter(element => (element.section === 'live high risk' && element.category === 'open'));
        this.oReport.high_risk_open_not_late.total = arrContainer[0].counter;

        //_ risk breakdown - open and late
        arrContainer = tmpAPIData.filter(element => (element.section === 'risk break down of open late' && element.category === 'high'));
        this.oReport.open_late_cases.high = arrContainer[0].counter;

        arrContainer = tmpAPIData.filter(element => (element.section === 'risk break down of open late' && element.category === 'medium'));
        this.oReport.open_late_cases.medium = arrContainer[0].counter;

        arrContainer = tmpAPIData.filter(element => (element.section === 'risk break down of open late' && element.category === 'low'));
        this.oReport.open_late_cases.low = arrContainer[0].counter;

        //_ risk breakdown - open
        arrContainer = tmpAPIData.filter(element => (element.section === 'risk break down of open' && element.category === 'high'));
        this.oReport.open_not_late_cases.high = arrContainer[0].counter;

        arrContainer = tmpAPIData.filter(element => (element.section === 'risk break down of open' && element.category === 'medium'));
        this.oReport.open_not_late_cases.medium = arrContainer[0].counter;

        arrContainer = tmpAPIData.filter(element => (element.section === 'risk break down of open' && element.category === 'low'));
        this.oReport.open_not_late_cases.low = arrContainer[0].counter;

        //_ observation by status
        arrContainer = tmpAPIData.filter(element => (element.section === 'total observation raised' && element.category === 'positive'));
        this.oReport.pn_all.positive = arrContainer[0].counter;

        arrContainer = tmpAPIData.filter(element => (element.section === 'total observation raised' && element.category === 'negative'));
        this.oReport.pn_all.negative = arrContainer[0].counter;
        

        //_ observation by risk type (severity)
        arrContainer = tmpAPIData.filter(element => (element.section === 'total observation by risk type' && element.category === 'high'));
        this.oReport.pn_all_by_severity.high = arrContainer[0].counter;

        arrContainer = tmpAPIData.filter(element => (element.section === 'total observation by risk type' && element.category === 'medium'));
        this.oReport.pn_all_by_severity.medium = arrContainer[0].counter;

        arrContainer = tmpAPIData.filter(element => (element.section === 'total observation by risk type' && element.category === 'low'));
        this.oReport.pn_all_by_severity.low = arrContainer[0].counter;


        //_ closure - high risk
        arrContainer = tmpAPIData.filter(element => (element.section === 'closure - high risk' && element.category === 'Closed - Late'));
        this.oReport.closure_freq_by_severity_high.closed_late = arrContainer[0].counter;

        arrContainer = tmpAPIData.filter(element => (element.section === 'closure - high risk' && element.category === 'Closed - Ontime'));
        this.oReport.closure_freq_by_severity_high.closed_ontime = arrContainer[0].counter;

        arrContainer = tmpAPIData.filter(element => (element.section === 'closure - high risk' && element.category === 'Open - Late'));
        this.oReport.closure_freq_by_severity_high.open_late = arrContainer[0].counter;


        //_ closure - medium risk
        arrContainer = tmpAPIData.filter(element => (element.section === 'closure - medium risk' && element.category === 'Closed - Late'));
        this.oReport.closure_freq_by_severity_medium.closed_late = arrContainer[0].counter;

        arrContainer = tmpAPIData.filter(element => (element.section === 'closure - medium risk' && element.category === 'Closed - Ontime'));
        this.oReport.closure_freq_by_severity_medium.closed_ontime = arrContainer[0].counter;

        arrContainer = tmpAPIData.filter(element => (element.section === 'closure - medium risk' && element.category === 'Open - Late'));
        this.oReport.closure_freq_by_severity_medium.open_late = arrContainer[0].counter;
        
        
        //_ closure - medium risk
        arrContainer = tmpAPIData.filter(element => (element.section === 'closure - low risk' && element.category === 'Closed - Late'));
        this.oReport.closure_freq_by_severity_low.closed_late = arrContainer[0].counter;

        arrContainer = tmpAPIData.filter(element => (element.section === 'closure - low risk' && element.category === 'Closed - Ontime'));
        this.oReport.closure_freq_by_severity_low.closed_ontime = arrContainer[0].counter;

        arrContainer = tmpAPIData.filter(element => (element.section === 'closure - low risk' && element.category === 'Open - Late'));
        this.oReport.closure_freq_by_severity_low.open_late = arrContainer[0].counter;
        

        //_ closure by epc 
        arrContainer = tmpAPIData.filter(element => (element.section === 'closure by epc'));
        arrContainer.sort((a, b) => a.grouping - b.grouping)
        this.oReport.cbn_epc = this.prepare_categorized_data(arrContainer, 'closure');

        //_ closure by safety 
        arrContainer = tmpAPIData.filter(element => (element.section === 'closure by safety'));
        arrContainer.sort((a, b) => a.grouping - b.grouping)
        this.oReport.cbn_safety = this.prepare_categorized_data(arrContainer, 'closure');

        //_ ytd by type
        arrContainer = tmpAPIData.filter(element => (element.section === 'ytd by type'));
        arrContainer.sort((a, b) => a.sorter - b.sorter)
        this.oReport.ytd_by_type = this.prepare_categorized_data(arrContainer, 'posneg');

        //_ ytd by status
        arrContainer = tmpAPIData.filter(element => (element.section === 'ytd by status'));
        arrContainer.sort((a, b) => a.sorter - b.sorter)
        this.oReport.ytd_by_status = this.prepare_categorized_data(arrContainer, 'closure');


        //_ draw chart
        this.draw_charts();
      }

      this.devMsg(this.oDev.debug, '', 'ge')
    },
    prepare_categorized_data( arrContainer, arrType='' ) {

      // console.log ('arrContainer by epc')
      // console.log (arrContainer)

      let arrRetVal = [];
      let prevEntry = '';
      let iArr = 1;

      arrContainer.forEach ((entry => {
        // console.log( 'prevEntry vs entry.grouping: ' )
        // console.log( prevEntry )
        // console.log( entry.grouping )

        if ( entry.grouping != prevEntry ) {
          // this.oReport.cbn_epc.push({
          if ( arrType == 'closure' ) {
            arrRetVal.push({
              category: entry.grouping,
              close_late: ( entry.category == 'Closed - Late' ) ? entry.counter : 0,
              close_ontime: ( entry.category == 'Closed - Ontime' ) ? entry.counter : 0,
              open_late: ( entry.category == 'Open - Late' ) ? entry.counter : 0,
            })
          } else if ( arrType == 'posneg' ) {
            arrRetVal.push({
              category: entry.grouping,
              positive: ( entry.category == 'Positive' ) ? entry.counter : 0,
              negative: ( entry.category == 'Negative' ) ? entry.counter : 0,
            })
          }

          prevEntry = entry.grouping;
        } else {
          // iArr = this.oReport.cbn_epc.length - 1;
          iArr = arrRetVal.length - 1;
          if ( arrType == 'closure' ) {
            ( entry.category == 'Closed - Late' ) ? arrRetVal[iArr].close_late = entry.counter : '';
            ( entry.category == 'Closed - Ontime' ) ? arrRetVal[iArr].close_ontime = entry.counter : '';
            ( entry.category == 'Open - Late' ) ? arrRetVal[iArr].open_late = entry.counter : '';
          } else if ( arrType == 'posneg' ) {
            ( entry.category == 'Positive' ) ? arrRetVal[iArr].positive = entry.counter : '';
            ( entry.category == 'Negative' ) ? arrRetVal[iArr].negative = entry.counter : '';
          }
        }
      }))

      // console.log( 'arrRetVal' )
      // console.log( arrRetVal )

      return arrRetVal;
    },

    //_ draw charts
    draw_charts() {
      //_ monthly
      this.draw_chart_risk_by_late_cases();
      this.draw_chart_risk_by_open_cases();
      this.draw_chart_safety_by_observation();
      this.draw_chart_safety_by_risk_type();
      this.draw_chart_closure_freq_by_severity_high();
      this.draw_chart_closure_freq_by_severity_medium();
      this.draw_chart_closure_freq_by_severity_low();

      this.draw_chart_bar_closure_by_epc();
      this.draw_chart_bar_closure_by_safety();

      // //_ YTD
      this.draw_chart_bar_ytd_by_type();
      this.draw_chart_bar_ytd_by_status();

      this.isLoadingInProgress = false;
    },
    draw_chart_risk_by_late_cases() {
      let chart_title = 'Risk Breakdown of Open Late Cases';
      let chart_template = cloneDeep(this.oTemplate.chart_pie_v1);
      chart_template.title.text = chart_title;

      this.obj_chart.risk_by_late_cases = chart_template;

      this.obj_chart.risk_by_late_cases.series[0].data = [];
      this.obj_chart.risk_by_late_cases.series[0].data.push({
        name: "High",
        y: this.oReport.open_late_cases.high,
        color: "#155075",
      });
      this.obj_chart.risk_by_late_cases.series[0].data.push({
        name: "Medium",
        y: this.oReport.open_late_cases.medium,
        color: "#5ABAB9",
      });
      this.obj_chart.risk_by_late_cases.series[0].data.push({
        name: "Low",
        y: this.oReport.open_late_cases.low,
        color: "#3F92D3",
      });

    },
    draw_chart_risk_by_open_cases() {
      let chart_title = 'Risk Breakdown of Open Cases';
      let chart_template = cloneDeep(this.oTemplate.chart_pie_v1);
      chart_template.title.text = chart_title;

      this.obj_chart.risk_by_open_cases = chart_template;

      this.obj_chart.risk_by_open_cases.series[0].data = [];
      this.obj_chart.risk_by_open_cases.series[0].data.push({
        name: "High",
        y: this.oReport.open_not_late_cases.high,
        color: "#155075",
      });
      this.obj_chart.risk_by_open_cases.series[0].data.push({
        name: "Medium",
        y: this.oReport.open_not_late_cases.medium,
        color: "#5ABAB9",
      });
      this.obj_chart.risk_by_open_cases.series[0].data.push({
        name: "Low",
        y: this.oReport.open_not_late_cases.low,
        color: "#3F92D3",
      });

    },
    draw_chart_safety_by_observation() {
      let chart_title = 'Total Observation Raised';
      let chart_template = cloneDeep(this.oTemplate.chart_pie_v1);
      chart_template.title.text = chart_title;

      this.obj_chart.safety_by_observation = chart_template;

      this.obj_chart.safety_by_observation.series[0].data = [];
      this.obj_chart.safety_by_observation.series[0].data.push({
        name: "Negative",
        y: this.oReport.pn_all.negative,
        color: "#5ABAB9",

      });
      this.obj_chart.safety_by_observation.series[0].data.push({
        name: "Positive",
        y: this.oReport.pn_all.positive,
        color: "#3F92D3",
      });
    },
    draw_chart_safety_by_risk_type() {
      let chart_title = 'Observation by Risk Type';
      let chart_template = cloneDeep(this.oTemplate.chart_pie_v1);
      chart_template.title.text = chart_title;

      this.obj_chart.safety_by_risk_type = chart_template;

      this.obj_chart.safety_by_risk_type.series[0].data = [];
      this.obj_chart.safety_by_risk_type.series[0].data.push({
        name: "High",
        y: this.oReport.pn_all_by_severity.high,
        color: "#155075",
      });
      this.obj_chart.safety_by_risk_type.series[0].data.push({
        name: "Medium",
        y: this.oReport.pn_all_by_severity.medium,
        color: "#5ABAB9",
      });
      this.obj_chart.safety_by_risk_type.series[0].data.push({
        name: "Low",
        y: this.oReport.pn_all_by_severity.low,
        color: "#3F92D3",
      });

    },
    draw_chart_closure_freq_by_severity_high() {
      let chart_title = 'Late Observation Closure Frequency - High';
      let chart_template = cloneDeep(this.oTemplate.chart_pie_v1);
      chart_template.title.text = chart_title;

      this.obj_chart.closure_freq_by_severity_high = chart_template;

      this.obj_chart.closure_freq_by_severity_high.series[0].data = [];
      this.obj_chart.closure_freq_by_severity_high.series[0].data.push({
        name: "Closed - Late",
        y: this.oReport.closure_freq_by_severity_high.closed_late,
        color: "#5ABAB9",
      });
      this.obj_chart.closure_freq_by_severity_high.series[0].data.push({
        name: "Closed - On Time",
        y: this.oReport.closure_freq_by_severity_high.closed_ontime,
        color: "#3F92D3",
      });
      this.obj_chart.closure_freq_by_severity_high.series[0].data.push({
        name: "Open - Late",
        y: this.oReport.closure_freq_by_severity_high.open_late,
        color: "#f51d1d",
      });

    },
    draw_chart_closure_freq_by_severity_medium() {
      let chart_title = 'Late Observation Closure Frequency - Medium';
      let chart_template = cloneDeep(this.oTemplate.chart_pie_v1);
      chart_template.title.text = chart_title;

      this.obj_chart.closure_freq_by_severity_medium = chart_template;

      this.obj_chart.closure_freq_by_severity_medium.series[0].data = [];
      this.obj_chart.closure_freq_by_severity_medium.series[0].data.push({
        name: "Closed - Late",
        y: this.oReport.closure_freq_by_severity_medium.closed_late,
        color: "#5ABAB9",
      });
      this.obj_chart.closure_freq_by_severity_medium.series[0].data.push({
        name: "Closed - On Time",
        y: this.oReport.closure_freq_by_severity_medium.closed_ontime,
        color: "#3F92D3",
      });
      this.obj_chart.closure_freq_by_severity_medium.series[0].data.push({
        name: "Open - Late",
        y: this.oReport.closure_freq_by_severity_medium.open_late,
        color: "#f51d1d",
      });
    },
    draw_chart_closure_freq_by_severity_low() {
      let chart_title = 'Late Observation Closure Frequency - Low';
      let chart_template = cloneDeep(this.oTemplate.chart_pie_v1);
      chart_template.title.text = chart_title;

      this.obj_chart.closure_freq_by_severity_low = chart_template;

      this.obj_chart.closure_freq_by_severity_low.series[0].data = [];
      this.obj_chart.closure_freq_by_severity_low.series[0].data.push({
        name: "Closed - Late",
        y: this.oReport.closure_freq_by_severity_low.closed_late,
        color: "#5ABAB9",
      });
      this.obj_chart.closure_freq_by_severity_low.series[0].data.push({
        name: "Closed - On Time",
        y: this.oReport.closure_freq_by_severity_low.closed_ontime,
        color: "#3F92D3",
      });
      this.obj_chart.closure_freq_by_severity_low.series[0].data.push({
        name: "Open - Late",
        y: this.oReport.closure_freq_by_severity_low.open_late,
        color: "#f51d1d",
      });
    },
    draw_chart_bar_closure_by_epc() {
      let chart_title = 'Closure by EPC';
      let chart_template = cloneDeep(this.oTemplate.chart_bar_v1);
      chart_template.title.text = chart_title;

      //_ populating data to chart
      // let tmpLate = [], tmpOntime = [];
      // this.oReport.cbn_epc.forEach( (entry => {
      //   chart_template.xAxis.categories.push(entry.category);
      //   tmpLate.push(entry.late);
      //   tmpOntime.push(entry.ontime);
      // }))
      // chart_template.series.push({name: 'On Time', data: tmpOntime});
      // chart_template.series.push({name: 'Late', data: tmpLate});

      let tmpCloseLate = [], tmpCloseOntime = [], tmpOpenLate = [];
      this.oReport.cbn_epc.forEach((entry => {
        chart_template.xAxis.categories.push(entry.category);
        tmpCloseLate.push(entry.close_late);
        tmpCloseOntime.push(entry.close_ontime);
        tmpOpenLate.push(entry.open_late);
      }))
      chart_template.series.push({ name: 'Closed - On Time', data: tmpCloseOntime });
      chart_template.series.push({ name: 'Closed - Late', data: tmpCloseLate });
      chart_template.series.push({ name: 'Open - Late', data: tmpOpenLate, color: '#f51d1d' });

      //_apply data to chart
      this.obj_chart.bar_closure_by_epc = chart_template;
    },
    draw_chart_bar_closure_by_safety() {
      let chart_title = 'Closure by Safety';
      let chart_template = cloneDeep(this.oTemplate.chart_bar_v1);
      chart_template.title.text = chart_title;

      //_ populating data to chart
      // let tmpLate = [], tmpOntime = [];
      // this.oReport.cbn_safety.forEach( (entry => {
      //   chart_template.xAxis.categories.push(entry.category);
      //   tmpLate.push(entry.late);
      //   tmpOntime.push(entry.ontime);
      // }))
      // chart_template.series.push({name: 'On Time', data: tmpOntime});
      // chart_template.series.push({name: 'Late', data: tmpLate});

      let tmpCloseLate = [], tmpCloseOntime = [], tmpOpenLate = [];
      this.oReport.cbn_safety.forEach((entry => {
        chart_template.xAxis.categories.push(entry.category);
        tmpCloseLate.push(entry.close_late);
        tmpCloseOntime.push(entry.close_ontime);
        tmpOpenLate.push(entry.open_late);
      }))
      chart_template.series.push({ name: 'Closed - On Time', data: tmpCloseOntime });
      chart_template.series.push({ name: 'Closed - Late', data: tmpCloseLate });
      chart_template.series.push({ name: 'Open - Late', data: tmpOpenLate, color: '#f51d1d' });

      //_apply data to chart
      this.obj_chart.bar_closure_by_safety = chart_template;
    },
    draw_chart_bar_ytd_by_type() {
      let chart_title = 'YTD by Type';
      let chart_template = cloneDeep(this.oTemplate.chart_bar_v1);
      chart_template.title.text = chart_title;

      //_ populating data to chart
      let tmpBar1 = [], tmpBar2 = [];
      this.oReport.ytd_by_type.forEach((entry => {
        chart_template.xAxis.categories.push(entry.category);
        tmpBar1.push(entry.positive);
        tmpBar2.push(entry.negative);
      }))
      chart_template.series.push({ name: 'Positive', data: tmpBar1 });
      chart_template.series.push({ name: 'Negative', data: tmpBar2 });

      //_apply data to chart
      this.obj_chart.bar_ytd_by_type = chart_template;
    },
    draw_chart_bar_ytd_by_status() {
      let chart_title = 'YTD by Status';
      let chart_template = cloneDeep(this.oTemplate.chart_bar_v1);
      chart_template.title.text = chart_title;

      //_ populating data to chart
      // let tmpBar1 = [], tmpBar2 = [];
      // this.oReport.ytd_by_status.forEach((entry => {
      //   chart_template.xAxis.categories.push(entry.category);
      //   tmpBar1.push(entry.close);
      //   tmpBar2.push(entry.open);
      // }))
      // chart_template.series.push({ name: 'Late - Closed', data: tmpBar1 });
      // chart_template.series.push({ name: 'Late - Open', data: tmpBar2 });
      let tmpCloseLate = [], tmpCloseOntime = [], tmpOpenLate = [];
      this.oReport.ytd_by_status.forEach((entry => {
        chart_template.xAxis.categories.push(entry.category);
        tmpCloseLate.push(entry.close_late);
        tmpCloseOntime.push(entry.close_ontime);
        tmpOpenLate.push(entry.open_late);
      }))
      chart_template.series.push({ name: 'Closed - On Time', data: tmpCloseOntime });
      chart_template.series.push({ name: 'Closed - Late', data: tmpCloseLate });
      chart_template.series.push({ name: 'Open - Late', data: tmpOpenLate, color: '#f51d1d' });


      //_apply data to chart
      this.obj_chart.bar_ytd_by_status = chart_template;
    },

    errorFunction(err, info) {
      this.error = `An error occurred: ${err.message}`;
      console.error(err, info);
      return false; // prevents the error from propagating further
    },

    action_on_modal(what_action, what_modal, isReset = true) {
      // this.isLoadingInProgress = true;

      if (what_action == 'show') {
        this.$refs[what_modal].show()
      } else {
        this.$refs[what_modal].hide();
      };
    },

    setDefaultMonthRange() {
      var currentDate = getcurrentDate();
      var localCurrentDate = new Date(currentDate);

      // get current date in yyyy-mm-dd format
      const currentYear = localCurrentDate.getFullYear();
      const currentMonth = String(localCurrentDate.getMonth() + 1).padStart(2, "0");
      const currentDay = String(localCurrentDate.getDate()).padStart(2, "0");
      this.filter.to_date = currentYear + "-" + currentMonth + "-" + currentDay;

      // get first day of last month in yyyy-mm-dd format
      var fromDate = new Date(localCurrentDate.setMonth(localCurrentDate.getMonth()));
      fromDate = new Date(fromDate.setDate(1));
      const fromYear = fromDate.getFullYear();
      const fromMonth = String(fromDate.getMonth() + 1).padStart(2, "0");
      const fromDay = String(fromDate.getDate()).padStart(2, "0");
      this.filter.from_date = fromYear + "-" + fromMonth + "-" + fromDay;

      this.oReport.selected.year = currentYear;
      this.oReport.selected.month = moment(currentMonth, 'MM').format('MMMM');
      this.oReport.selected.month_mmm = moment(currentMonth, 'MM').format('MMM');
      this.oReport.selected.currDDMmmYYYY = currentDay + '-' + moment(currentMonth, 'MM').format('MMM') + '-' + currentYear

      console.log("Range Date");
      console.log(this.filter);
    },

  },
}

</script>

<style scoped>
label {
  font-weight: normal !important;
}

.bg-default-dashboard {
  background-color: #082A2F;
  /* background-color: #f1e5e9; */
  /* background-size: cover; */
  /* position:fixed; */
  padding: 0;
  margin: 0;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.toolbar button {
  margin-left: 5px;
  margin-right: 5px;
  padding: 2px;
}

.dashboard-panel-risk-high {
  background-color: #ed0101;
}

.dashboard-panel-risk-medium {
  background-color: #ffb645;
}

.dashboard-panel-risk-low {
  background-color: #04ac20;
}

.hr {
  background-color: #fff;
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;

}
</style>